import axiosInstance from '../../../axiosInstance'
import apiEndpoints from '../../../api'
import { notify } from '../../../../utils/notification'

export const getCountriesReq = (action) => {
    const url = apiEndpoints.SOCIETY_GET_COUNTRIES_API
    return axiosInstance.get(url )
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            if (errors.response?.data?.statusCode === 400 || errors.response?.data?.statusCode === 404) {
                notify('error', errors.response?.data?.message);
            } else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
}
export const getStatesReq = (action) => {
    const countryId = action?.data?.countryId || ''
    const url = apiEndpoints.SOCIETY_GET_STATE_API
    return axiosInstance.get(url, { params: { countryId } })
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            if (errors.response?.data?.statusCode === 400 || errors.response?.data?.statusCode === 404) {
                notify('error', errors.response?.data?.message);
            } else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
}
export const getCitiesReq = (action) => {
    const stateId = action?.data?.stateId || ''
    const url = apiEndpoints.SOCIETY_GET_CITY_API
    return axiosInstance.get(url, { params: { stateId } })
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            if (errors.response?.data?.statusCode === 400 || errors.response?.data?.statusCode === 404) {
                notify('error', errors.response?.data?.message);
            } else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
}